<template>
  <!-- 栅格间隔配置
       @author: 王汝鹏
       @date: 2019-9-13
   -->
  <div class="setting-item">
    <el-form-item label="栅格间隔"> 
      <el-input type="number" 
                v-model.number="gutter"
                placeholder="请输入栅格间隔"></el-input>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 基础属性-栅格间隔配置项
     *  @description 将 gutter 字段映射到当前 gutter 计算属性
     *  @return {Number}
     *  @author 王汝鹏
     *  @version 2019-09-10
     */
    ...mapComputed({
      gutter: { 
        parent: i => i.baseOption,
        attr: "gutter" 
      }
    }),
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingGridGutter.vue